import script from "./AtomSubTitle.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomSubTitle.vue?vue&type=script&lang=ts&setup=true"

import "./AtomSubTitle.vue?vue&type=style&index=0&id=f0376e5a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0376e5a"]])

export default __exports__